// extracted by mini-css-extract-plugin
module.exports = {"cardInfo":"components_cardInfo__yVIp-","readCardLoading":"components_readCardLoading__1Ej0D"};